<template>
  <!-- 集中式 -->
  <Centralized v-if="isCentralized" :stationId="stationId" v-bind="$attrs"/>
  <!-- 分布式 -->
  <Distributed v-else :stationId="stationId" v-bind="$attrs"/>
</template>




<script setup>
import { computed } from 'vue';
import useAppStore from '@/store/modules/app';
import Distributed from './Distributed.vue';
import Centralized from './Centralized.vue';

import { useRoute } from 'vue-router';
const route = useRoute()
const stationId = computed(() => route.query.stationId)

const appStore = useAppStore()

// 是否集中式
const isCentralized = computed(() => {
  const station = appStore.getStationById(stationId.value)
  return station?.energyStorageType === 2
})


</script>
